import { Colors } from './colors'

export interface ILoadingIndicator {
  background: string
  borderRadius: string
  color: string
  overlayBackground: string
  overlayOpacity: string
  padding: string
}

export const LoadingIndicator: ILoadingIndicator = {
  background: Colors.primaryLight,
  borderRadius: '0.25rem',
  color: Colors.white,
  overlayBackground: Colors.primaryDark,
  overlayOpacity: '0.3',
  padding: '1rem'
}
